<ng-container>
	<app-ea-spinner *ngIf="!exploitations"></app-ea-spinner>
	<!--TODO <my-error-component *ngIf="data.error" [error]="data.error"></my-error-component> -->
	<div *ngIf="exploitations">
		<div class="flex align-items-center justify-content-between pt-3 pb-2 px-4" id="header">
			<div class="pl-3 overflow-hidden">
				<span class="block text-4xl font-bold">{{ "cheptel.liste" | translate }}</span>
			</div>
		</div>
		<div class="col-12">
			<div class="card">
				<p-toast></p-toast>

				<p-table
					#dt
					[value]="exploitations"
					[(selection)]="selectedExploitation"
					dataKey="numeroCheptel"
					styleClass="p-datatable-exploitations"
					[rowHover]="true"
					[rows]="15"
					[paginator]="true"
					[filterDelay]="0"
					[globalFilterFields]="['name', 'numeroCheptel', 'enabled']">
					<ng-template pTemplate="caption">
						<div class="flex p-flex-column md:flex-row md:justify-content-between table-header">
							<span class="p-input-icon-left">
								<i class="pi pi-search"></i>
								<input
									pInputText
									type="text"
									(input)="dt.filterGlobal($event.target.value, 'contains')"
									placeholder="Recherche" />
							</span>
							<button
								pButton
								pRipple
								style="float: right"
								label="Ajouter un cheptel"
								icon="pi pi-plus"
								class="p-button-success mr-2 mb-2"
								(click)="openCreationCheptelDialog()"></button>
						</div>
					</ng-template>
					<ng-template pTemplate="header">
						<tr>
							<th pSortableColumn="name">
								<div class="flex justify-content-between align-items-center">
									{{ "global.nom" | translate }}
									<p-sortIcon field="name"></p-sortIcon>
									<p-columnFilter
										type="text"
										field="name"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="numeroCheptel">
								<div class="flex justify-content-between align-items-center">
									{{ "global.numero" | translate }}
									<p-sortIcon field="numeroCheptel"></p-sortIcon>
									<p-columnFilter
										type="text"
										field="numeroCheptel"
										display="menu"
										class="ml-auto"></p-columnFilter>
								</div>
							</th>
							<th pSortableColumn="enabled">
								<div class="flex justify-content-between align-items-center">
									{{ "global.etat" | translate }}
									<p-sortIcon field="enabled"></p-sortIcon>
								</div>
							</th>
						</tr>
					</ng-template>
					<ng-template pTemplate="body" let-exploitation>
						<tr class="p-selectable-row" (click)="onSelection(exploitation)">
							<td>
								<span class="p-column-title">{{ "global.nom" | translate }}</span>
								{{ exploitation.name }}
							</td>
							<td>
								<span class="p-column-title">{{ "global.numero" | translate }}</span>
								<span class="image-text" style="margin-left: 0.5em; vertical-align: middle">{{
									exploitation.numeroCheptel
								}}</span>
							</td>
							<td>
								<span class="p-column-title">{{ "global.etat" | translate }}</span>
								<span *ngIf="exploitation.enabled === 'ENABLED'" class="customer-badge status-active">{{
									exploitation.enabled | enumToKey | translate
								}}</span>
								<span
									*ngIf="exploitation.enabled === 'DISABLED'"
									class="customer-badge status-desactive"
									>{{ exploitation.enabled | enumToKey | translate }}</span
								>
							</td>
						</tr>
					</ng-template>
					<ng-template pTemplate="emptymessage">
						<tr>
							<td colspan="8">{{ "cheptel.pasdecheptel" | translate }}</td>
						</tr>
					</ng-template>
				</p-table>
				<p-dialog
					[(visible)]="showCheptelNewDialog"
					[style]="{ width: '450px' }"
					header="Création d'un cheptel"
					[modal]="true"
					styleClass="p-fluid">
					<ng-template pTemplate="content">
						<div class="field">
							<label for="name">{{ "cheptel.numero" | translate }}</label>
							<input
								type="text"
								pInputText
								id="name"
								[(ngModel)]="newCheptelDraft.numeroCheptel"
								required
								autofocus />
							<small class="p-invalid red-text" *ngIf="errorType === 'emptyField'">{{
								"submit.champobligatoire" | translate
							}}</small>
							<small class="p-invalid red-text" *ngIf="errorType === 'length'">{{
								"submit.longueur8" | translate
							}}</small>
							<small class="p-invalid red-text" *ngIf="errorType === 'format'">{{
								"submit.quedeschiffres" | translate
							}}</small>
						</div>
						<div class="field">
							<label class="mb-3">{{ "permission.offreAbonnement" | translate }}</label>
							<div class="formgrid grid">
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category1"
										name="category"
										value="ESSENTIEL"
										[(ngModel)]="newCheptelDraft.offreAbonnement"></p-radioButton>
									<label for="category1">{{ "offreabonnement.essentiel" | translate }}</label>
								</div>
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category2"
										name="category"
										value="PERFORMANCE"
										[(ngModel)]="newCheptelDraft.offreAbonnement"></p-radioButton>
									<label for="category2">{{ "offreabonnement.performance" | translate }}</label>
								</div>
							</div>
						</div>
						<div class="field">
							<label class="mb-3">{{ "permission.exploitation" | translate }}</label>
							<div class="formgrid grid">
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category1"
										name="category"
										value="ENABLED"
										[(ngModel)]="newCheptelDraft.enabled"></p-radioButton>
									<label for="category1">{{ "etat.active" | translate }}</label>
								</div>
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category2"
										name="category"
										value="DISABLED"
										[(ngModel)]="newCheptelDraft.enabled"></p-radioButton>
									<label for="category2">{{ "etat.desactive" | translate }}</label>
								</div>
							</div>
						</div>
						<div class="field">
							<label class="mb-3">{{ "permission.type" | translate }}</label>
							<div class="formgrid grid">
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category1"
										name="category"
										value="LIVE"
										[(ngModel)]="newCheptelDraft.type"></p-radioButton>
									<label for="category1">{{ "exploitationtype.live" | translate }}</label>
								</div>
								<div class="field-radiobutton col-6">
									<p-radioButton
										id="category2"
										name="category"
										value="FAKE"
										[(ngModel)]="newCheptelDraft.type"></p-radioButton>
									<label for="category2">{{ "exploitationtype.fake" | translate }}</label>
								</div>
							</div>
						</div>
						<div class="field">
							<label class="mb-3">{{ "permission.features" | translate }}</label>
							<div class="card">
								<div style="text-align: right" *ngIf="hasProperty('featureDisplayAlertes')">
									<label style="float: left" class="mb-3">{{
										"permission.featureDisplayAlertes" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureDisplayAlertes === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureDisplayAlertes = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureDisplayAlertes')" />
								<div style="text-align: right" *ngIf="hasProperty('featureDisplayTaches')">
									<label style="float: left" class="mb-3">{{
										"permission.featureDisplayTaches" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureDisplayTaches === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureDisplayTaches = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureDisplayTaches')" />
								<div style="text-align: right" *ngIf="hasProperty('featureSaisieIpe')">
									<label style="float: left" class="mb-3">{{
										"permission.featureSaisieIpe" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureSaisieIpe === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureSaisieIpe = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureSaisieIpe')" />
								<div style="text-align: right" *ngIf="hasProperty('featureSaisiePesee')">
									<label style="float: left" class="mb-3">{{
										"permission.featureSaisiePesee" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureSaisiePesee === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureSaisiePesee = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureSaisiePesee')" />
								<div style="text-align: right" *ngIf="hasProperty('featureSaisieReproduction')">
									<label style="float: left" class="mb-3">{{
										"permission.featureSaisieReproduction" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureSaisieReproduction === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureSaisieReproduction = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureSaisieReproduction')" />
								<div style="text-align: right" *ngIf="hasProperty('featureSaisieSanitaire')">
									<label style="float: left" class="mb-3">{{
										"permission.featureSaisieSanitaire" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureSaisieSanitaire === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureSaisieSanitaire = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureSaisieSanitaire')" />
								<div style="text-align: right" *ngIf="hasProperty('featureUpdateLots')">
									<label style="float: left" class="mb-3">{{
										"permission.featureUpdateLots" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureUpdateLots === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureUpdateLots = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureCommandeIA')" />
								<div style="text-align: right" *ngIf="hasProperty('featureCommandeIA')">
									<label style="float: left" class="mb-3">{{
										"permission.featureCommandeIA" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureCommandeIA === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureCommandeIA = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
								<hr *ngIf="hasProperty('featureChatBot')" />
								<div style="text-align: right" *ngIf="hasProperty('featureChatBot')">
									<label style="float: left" class="mb-3">{{
										"permission.featureChatBot" | translate
									}}</label>
									<p-inputSwitch
										[ngModel]="newCheptelDraft.featureChatBot === 'ENABLED'"
										(ngModelChange)="
											newCheptelDraft.featureChatBot = $event ? 'ENABLED' : 'DISABLED'
										"></p-inputSwitch>
								</div>
							</div>
						</div>
					</ng-template>

					<ng-template pTemplate="footer">
						<button
							pButton
							pRipple
							label="Annuler"
							icon="pi pi-times"
							class="p-button-text"
							(click)="hideCreationCheptelDialog()"></button>
						<button
							pButton
							pRipple
							label="Enregistrer"
							icon="pi pi-check"
							class="p-button-text"
							(click)="addCheptel()"></button>
					</ng-template>
				</p-dialog>
			</div>
		</div>
	</div>
</ng-container>
